import moment from "moment";

export interface Email {
  blockTillDate: string;
  email: string;
  emailId: number;
  expiryDate: string;
  id: number;
  isPrimary: boolean;
  isVerified: boolean;
  mobileId: number;
  status: number;
}

export interface Mobile extends Email {
  mobile: string;
}

export function isExpired(expiryDate?:string) {
  return expiryDate && expiryDate !== "0001-01-01T00:00:00" && moment(expiryDate).isAfter(Date.now());
}

export function isBlocked(blockTillDate?:string) {
  return (blockTillDate && moment(blockTillDate).isAfter(Date.now())) || false
}
